import React, { useEffect, useState } from "react";
import { DatePicker } from "@fluentui/react";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import CommonDataTable from "../CommonDataTable";
import { GetAmsDataByJobId } from "../../Services/JobConfigurationServices";
import { ReportExcelExport } from "../ExportExcel/ReportExcelExport";
import { format } from "date-fns";

const AmsUpdateReport = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [record, setRecord] = useState([]);
  const column = [
    {
      name: "Job Id",
      selector: (row) => row?.JobId,
      style: { fontSize: "9px !important" },
      grow: 1.2,
    },
    {
      name: "ReviewStatus",
      selector: (row) => {
        if (row?.ReviewStatus === "Completed") {
          return <span style={{ color: "green" }}>Completed</span>;
        }

        return <span style={{ color: "red" }}>NA</span>;
      },
      wrap: true,
      style: { fontSize: "9px !important" },
      grow: 0.9,
    },
    {
      name: "Reviwed By",
      selector: (row) => row?.ReviewedBy,
      wrap: true,
      style: { fontSize: "9px !important" },
      grow: 1.3,
    },
    {
      name: "Dispatched By",
      selector: (row) => row?.DispatchedBy,
      style: { fontSize: "9px !important" },
      grow: 1.3,
    },
    {
      name: "AmsStatus",
      selector: (row) => {
        if (row?.AmsStatus === "Completed") {
          return <span style={{ color: "green" }}>Completed</span>;
        }

        return <span style={{ color: "red" }}>NA</span>;
      },
      style: { fontSize: "9px !important" },
      grow: 0.8,
    },
    {
      name: "AmsCompleted By",
      selector: (row) => row?.AmsCompletedBy,
      style: { fontSize: "9px !important" },
      grow: 1.3,
    },
    {
      name: "AmsCompleted On",
      selector: (row) => row?.AmsCompletedOn,
      grow: 1.1,
      style: { fontSize: "9px !important" },
    },
  ];

  const onFromDateChange = (date) => {
    if (date) {
      const formattedDate =format(date, "M/d/yyyy");
      setFromDate(formattedDate);
      setToDate(null); // Reset toDate when fromDate changes
    } else {
      setFromDate(null);
    }
  };

  const onToDateChange = (date) => {
    if (date) {
      const formattedDate =format(date, "M/d/yyyy");
      setToDate(formattedDate);
    } else {
      setToDate(null);
    }
  };

  const searchRecords = async () => {
    document.body.classList.add("loading-indicator");
    try {
      let data = await GetAmsDataByJobId("", fromDate || "", toDate || "", 0);
      if (data && Array.isArray(data)) {
        data = data.map((e, index) => {
          if (e?.AmsCompletedOn) {
            e.AmsCompletedOn = new Date(e.AmsCompletedOn).toLocaleString();
          }
          if (e?.DispatchedOn) {
            e.DispatchedOn = new Date(e.DispatchedOn).toLocaleString();
          }
          if (e.AmsStatus) {
            e.AmsStatus = "Completed";
          } else {
            e.AmsStatus = "NA";
          }
          if (e.ReviewStatus) {
            e.ReviewStatus = "Completed";
          } else {
            e.ReviewStatus = "NA";
          }
          e["S.No"] = index + 1;
          return e;
        });
        setRecord(data);
      } else {
        setRecord([]);
      }
    } catch (error) {
      document.body.classList.remove("loading-indicator");
      console.log(error);
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  const onExportClick = async () => {
    document.body.classList.add("loading-indicator");
    try {
      const FormattedDataForExport = record.map((e) => {
        return {
          "S.No": e["S.No"],
          JobId: e["JobId"],
          DispatchedBy: e["DispatchedBy"],
          DispatchedOn: e["DispatchedOn"],
          ReviewStatus: e["ReviewStatus"],
          ReviewedBy: e["ReviewedBy"],
          AmsStatus: e["AmsStatus"],
          AmsCompletedBy: e["AmsCompletedBy"],
          AmsCompletedOn: e["AmsCompletedOn"],
        };
      });

      const dataForExport = [{ data: FormattedDataForExport }];
      const fileName = `Ams Update Report - ${new Date().toLocaleDateString()}`;
      await ReportExcelExport(dataForExport, fileName);
    } catch (error) {
      document.body.classList.remove("loading-indicator");
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          padding: "10px",
        }}
      >
        <DatePicker
          style={{ width: "200px" }}
          placeholder="From Date..."
          onSelectDate={onFromDateChange}
          value={fromDate ? new Date(fromDate) : null}
          allowTextInput
        />
        <DatePicker
          style={{ width: "200px" }}
          placeholder="To Date..."
          onSelectDate={onToDateChange}
          value={toDate ? new Date(toDate) : null}
          minDate={fromDate ? new Date(fromDate) : null}
          //   disabled={!fromDate}
          allowTextInput
        />
        <PrimaryButton
          disabled={!fromDate && !toDate}
          onClick={() => {
            searchRecords();
          }}
        >
          Search
        </PrimaryButton>
        <PrimaryButton
          disabled={!(record?.length > 0)}
          onClick={() => {
            onExportClick();
          }}
        >
          Export
        </PrimaryButton>
      </div>
      <div>
        <div>
          <CommonDataTable
            key={"jData"}
            column={column}
            data={record}
            headerFontSize="10px"
          />
        </div>
      </div>
    </div>
  );
};

export default AmsUpdateReport;
